import React from 'react';
import Button from '@react/react-spectrum/Button';
import { connect } from 'react-redux';
import { CONTACT_HELPDESK } from '../../config/constants';
import { upsertAccount, rtrnSaveNExt, setLocaleOnNext, upsertContact } from './CommonButtonsActions';
import { getFormValues } from 'redux-form';
import { saveAndExitUpdate } from '../../storeManagement/action';
import { setLocaleWithFallback } from '../../../actions';
import { isSavingToggle } from '../../../actions/commonActions';
import { Translate } from 'react-redux-i18n';


const createButton = (prop) => {
  const allbuttonFunc = addFunctions(prop.allbuttonFunc, prop);
  return getButtons(prop.btn, allbuttonFunc, prop.isValidated, prop);
};

const setDisabledProps = (btnEle, propDetails) => {
  if (propDetails?.isDetailsAvailableToProceed) {
    return btnEle.btnToValidate ? propDetails.isValidated : false;
  }

  return true; // Check if all the necessary details are present to proceed, else disable the button
};

function getButtons(btns, allbuttonFunc, isValidated, prop) {
  let finalBtns = [];
  btns.forEach((btn) => {
    let propToButton = {};
    if (btn.btnProp) {
      btn.btnProp.forEach((propName) => {
        if (propName === "prop") {
          propToButton = { ...prop };
        }
        propToButton.btnLabel = btn.btnLabel;
      });
    }
    finalBtns.push(
      <Button
        variant={btn.btnVariant}
        // TO BE UPDATED back
        disabled={setDisabledProps(btn, prop)}
        // disabled={false}
        onClick={() =>
          allbuttonFunc[btn.btnFunc] !== undefined
            ? allbuttonFunc[btn.btnFunc](propToButton ? propToButton : "")
            : {}
        }
      >
        <Translate value={"registration." + btn.btnLabel} />
      </Button>,
    );
  });
  return finalBtns;
}

// btnFunc : onNextButton
const mapStateToProps = (state) => ({
  currentStage: state.registration.currentStage,
  isSaving: state.common.isSaving,
  isValidated: state.registration.isValidated,
  registration: getFormValues("registration")(state),
  isDetailsAvailableToProceed: state.registration.isDetailsAvailableToProceed,
});

const mapDispatchToProps = (dispatch) => ({
  onClkSaveAndExit: (bool) => dispatch(saveAndExitUpdate(bool)),
  setLocaleAction: (locale) => dispatch(setLocaleWithFallback(locale)),
  is_saving: (e) => dispatch(isSavingToggle(e)),
});

export const MakeButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(createButton);

// outer array for Different pages
// inner array is for Buttons like previous, next, etc
export const ButtonMap =
[
    [
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnToValidate : true,
            btnFunc : 'setLocaleOnNext',
            btnProp : ['prop'],
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'onNextButton',
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Save and Exit',
            btnVariant : 'primary',
            btnFunc : 'upsertAccount',
            btnProp : ['prop'],
            btnToValidate : true
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'upsertAccount',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Save and Exit',
            btnVariant : 'primary',
            btnToValidate : true,
            btnFunc : 'upsertContact',
            btnProp : ['prop']
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnToValidate : true,
            btnFunc : 'upsertContact',
            btnProp : ['prop']
        }
    ],
    [ 
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Register',
            btnVariant : 'cta',
            btnFunc : 'upsertAccount',
            btnToValidate : true,
            btnProp : ['prop']
        }
    ],
    [
        {
            btnLabel : 'Return_to_Adobe_Channel_Partners',
            btnVariant : 'cta',
            btnFunc : 'openChannelPartner'
        },
        {
            btnLabel : 'Contact Helpdesk',
            btnVariant : 'primary',
            btnFunc : 'openHelpDesk'
        }
    ],
    [
        {
            btnLabel : 'Continue Enrollment',
            btnVariant : 'primary',
            btnFunc : 'rtrnSaveNExt'
        }
    ],
]

const addFunctions = (allbuttonFunc, onClkSaveAndExit) => {
    allbuttonFunc.upsertContact = upsertContact;
    allbuttonFunc.openChannelPartner = openChannelPartner;
    allbuttonFunc.openHelpDesk = openHelpDesk;
    allbuttonFunc.upsertAccount = upsertAccount;
    allbuttonFunc.rtrnSaveNExt = rtrnSaveNExt;
    allbuttonFunc.setLocaleOnNext = setLocaleOnNext;
    return allbuttonFunc;
}

const openChannelPartner = () => {
  window.open(window.apcConfig.partner.home, "_blank");
};
const openHelpDesk = () => {
  window.open(CONTACT_HELPDESK, "_blank");
};
